/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './sendNotification.defs.js'
export * as $defs from './sendNotification.defs.js'
